import React from 'react';
import {
  Box, Container, Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ViewProps } from './types';
import ZSpinner from '../../../components/z-lib/z-spinner';
import ProfileCard from '../cards/profiles-card';
import ReviewCard from '../cards/review-card';
import AboutCard from '../cards/about-card';
import TeamCard from '../cards/team-card';
import Sidebar from '../sidebar';

const AboutView = ({
  assignedAgentId,
  partner,
  partnerId,
  participants,
}: ViewProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

  if (isMobile) {
    return (
      <Container maxWidth="lg">
        <Box sx={{
          pt: {
            desktop: 5,
            mobile: 3,
          },
          pb: {
            desktop: 9.5,
            mobile: 5,
          },
        }}
        >
          <Grid
            container
            spacing={{
              desktop: 8,
            }}
          >
            <Grid item desktop={4} mobile={12}>
              {participants && (
              <Box sx={{ mb: 3 }} id="aboutpage">
                <Typography variant="h4" sx={{ mb: 2 }}>Your team</Typography>
                <TeamCard assignedAgentId={assignedAgentId} participants={participants} />
              </Box>
              )}
              <Box sx={{ mb: 3 }}>
                <ProfileCard partner={partner} hideWebsite />
              </Box>
            </Grid>

            <Grid item desktop={8} mobile={12}>
              {partner?.aboutUs && (
              <AboutCard aboutUs={partner.aboutUs} />
              )}
              {partnerId ? (
                <ReviewCard partnerId={partnerId} />
              ) : (
                <Box display="flex" justifyContent="center">
                  <ZSpinner />
                </Box>
              )}
            </Grid>

          </Grid>
        </Box>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        flex: 1,
        pt: 3.75,
      }}
    >
      <Grid
        container
        spacing={1}
      >
        <Grid
          item
          desktop={4}
          sx={{
            display: 'block',
            borderRight: '1px solid #C2C2C2',
          }}
        >
          {/* Sticky Sidebar */}
          <Sidebar partner={partner} isAboutPage />
        </Grid>
        <Grid
          item
          desktop={8}
        >
          <Box pl={3}>
            {partner?.aboutUs && (
            <AboutCard aboutUs={partner.aboutUs} />
            )}
            {partnerId ? (
              <ReviewCard partnerId={partnerId} />
            ) : (
              <Box display="flex" justifyContent="center">
                <ZSpinner />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutView;
